import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import {
	Loader,
	Paragraph,
	Title,
	ChartDoughnut,
	BreadCrumb,
	Small,
} from '@components/atoms'
import { QuestionSimulateResult } from '@components/molecules'
import {
	ArrowClockwise28Regular,
	CalendarLtr16Regular,
	Check20Regular,
	Clock16Regular,
	DataHistogram20Regular,
} from '@fluentui/react-icons'
import { ResultSimulateQuestionType } from '@models/simulated.model'
import { simulatedAPI } from '@services/SimulatedAPI'
import moment from 'moment'

import { SimulateStyles } from '../style'
import { stylesSimulatedExam } from './style'

const { container, title: titleStyle } = SimulateStyles
const {
	CardSimulateResult,
	containerCards,
	titleResult,
	containerNewSimulate,
	iconNewSimulate,
	Icon,
	ActionBar,
	containerActionBar,
	containerStatistic,
	cardStatistic,
} = stylesSimulatedExam

export type SelectWeek = {
	selectWeek: { label: string; value: string }
}

export const SimulateResult = () => {
	const [resultQuestions, setResultQuestions] = useState<
		Array<ResultSimulateQuestionType>
	>([])
	const [points, setPoints] = useState<string>('')
	const [actionBarValue, setActionBarValue] = useState<string>('')

	const [getResultSimulate, { data, isSuccess, isLoading }] =
		simulatedAPI.useGetSimulateResultMutation()

	/* const [simulateRating, { isSuccess: isSuccessRating }] =
		simulatedAPI.usePostSimulateRatingMutation() */

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [searchParams, setSearchParams] = useSearchParams()
	const mookID = searchParams.get('mookID')
	const resolutionId = searchParams.get('resolutionId')

	const handleActionBar = (name: string) => {
		if (name === actionBarValue) {
			setActionBarValue('')
		} else {
			setActionBarValue(name)
		}
	}

	/* 	const handleRatingSimulate = (rating: number) => {
		simulateRating({ rating, categoryId: data?.categoryId || 0 })
	} */

	useEffect(() => {
		if (mookID && resolutionId) {
			getResultSimulate({ mookID, resolutionId })
		}
	}, [getResultSimulate, mookID, resolutionId])

	useEffect(() => {
		if (isSuccess && data) {
			setResultQuestions(data.questions)
			setPoints(data.points)
		}
	}, [data, isSuccess])

	/* 	useEffect(() => {
		if (isSuccessRating) {
			dispatch(notificationCreators.show(successMessages.updateRating))
			if (data) {
				getRating({ mookID: data.categoryId })
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccessRating, data, getRating]) */

	return (
		<div className={container()}>
			<div>
				<BreadCrumb
					buttonReturn
					locations={[
						{ name: 'Simulados', link: '/simulados' },
						{
							name: data?.category || '',
							link: `/simulados/${data?.categoryId}`,
						},
						{ name: 'Prova', link: `/simulados/prova/${mookID}` },
						{
							name: `${data?.title || ''} - Resolução ${data?.resolution}`,
							link: '',
						},
					]}
				/>

				<div className={titleStyle()}>
					<Title variant='h1' color='$neutral160'>
						{`${data?.title || ''} - Resolução ${data?.resolution}`}
					</Title>
				</div>
			</div>

			<div>
				{isLoading && resultQuestions.length <= 0 ? (
					<>
						<Loader />
					</>
				) : (
					<>
						<div className={containerCards()}>
							<CardSimulateResult
								css={{
									width: '95px',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'flex-start',
									gap: '16px',
								}}
							>
								<Paragraph
									paragraphType='p3'
									css={{
										color: '$neutral100',
										display: 'flex',
										alignItems: 'center',
										gap: '4px',
									}}
								>
									<Check20Regular />
									Nota
								</Paragraph>

								<Title variant='h2' color='$blue20'>
									{points}
								</Title>
							</CardSimulateResult>

							<CardSimulateResult
								css={{
									width: '147px',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'flex-start',
									gap: '16px',
								}}
							>
								<Paragraph
									paragraphType='p3'
									css={{
										color: '$neutral100',
										display: 'flex',
										alignItems: 'center',
										gap: '4px',
									}}
								>
									<Clock16Regular />
									Tempo de Prova
								</Paragraph>

								<Title variant='h5' color='$neutral80'>
									{`${data?.conclusionTime}`}
								</Title>
							</CardSimulateResult>

							<CardSimulateResult
								css={{
									width: '136px',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'flex-start',
									gap: '16px',
								}}
							>
								<Paragraph
									paragraphType='p3'
									css={{
										color: '$neutral100',
										display: 'flex',
										alignItems: 'center',
										gap: '4px',
									}}
								>
									<CalendarLtr16Regular />
									Data
								</Paragraph>

								<Title variant='h5' color='$neutral80'>
									{`${moment(data?.createdAt).format('DD/MM/YYYY')}`}
								</Title>
							</CardSimulateResult>

							<Link to={`/simulados/prova/${mookID}`}>
								<CardSimulateResult css={{ cursor: 'pointer' }}>
									<div className={containerNewSimulate()}>
										<Paragraph
											paragraphType='p3'
											css={{
												color: '$neutral100',
											}}
										>
											Refazer simulado
										</Paragraph>
										<Paragraph
											paragraphType='p3'
											css={{
												color: '$neutral70',
												maxWidth: '187px',
											}}
										>
											Você pode refazer o simulado quantas vezes quiser.
										</Paragraph>
									</div>
									<button type='button' className={iconNewSimulate()}>
										<ArrowClockwise28Regular />
									</button>
								</CardSimulateResult>
							</Link>

							<CardSimulateResult
								css={{
									width: '100%',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'flex-start',
									gap: '16px',
									'@sm': {
										width: '110px',
									},
								}}
							>
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										width: '100%',
									}}
								>
									<Small
										smallType='small1'
										css={{
											color: '$neutral70',
										}}
									>
										Media Geral
									</Small>
								</div>
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										width: '100%',
									}}
								>
									<Title variant='h2' color='$blue20'>
										{data ? String(data.globalPoints.toFixed(2)) : ''}
									</Title>
								</div>
							</CardSimulateResult>
						</div>

						<div className={containerActionBar()}>
							{/* <ActionBar
								selected={actionBarValue === 'error'}
								onClick={() => {
									handleActionBar('error')
								}}
							>
								<Icon>
									<ErrorCircle16Regular />
								</Icon>
								<p>Reportar erro</p>
							</ActionBar>
							<ActionBar
								selected={actionBarValue === 'historic'}
								onClick={() => {
									handleActionBar('historic')
								}}
							>
								<Icon>
									<ErrorCircle16Regular />
								</Icon>
								<p>Histórico de Respostas</p>
							</ActionBar> */}
							<ActionBar
								selected={actionBarValue === 'statistic'}
								onClick={() => {
									handleActionBar('statistic')
								}}
							>
								<Icon>
									<DataHistogram20Regular />
								</Icon>
								<p>Estatisticas</p>
							</ActionBar>
						</div>

						<div className={titleResult()}>
							<Title variant='h1' color='$neutral160'>
								Questões
							</Title>
						</div>

						{actionBarValue === 'statistic' && (
							<div className={containerStatistic()}>
								<ChartDoughnut
									showTitle={false}
									hits={
										resultQuestions.filter((item) => item.isCorrect === true)
											.length
									}
									errors={
										resultQuestions.filter((item) => item.isCorrect === false)
											.length
									}
								/>

								<ul className={cardStatistic()}>
									<li>
										<h4>
											{
												resultQuestions.filter(
													(item) =>
														item.isCorrect === true || item.isCorrect === false
												).length
											}
										</h4>
										<h5>Resolvidas</h5>
									</li>
									<li>
										<h4>
											{
												resultQuestions.filter(
													(item) => item.isCorrect === true
												).length
											}
										</h4>
										<h5>Corretas</h5>
									</li>
									<li>
										<h4>
											{
												resultQuestions.filter(
													(item) => item.isCorrect === false
												).length
											}
										</h4>
										<h5>Erradas</h5>
									</li>
								</ul>
							</div>
						)}

						<div
							style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}
						>
							{resultQuestions &&
								resultQuestions.length > 0 &&
								resultQuestions.map((value, index) => (
									<QuestionSimulateResult
										value={value}
										index={index + 1}
										key={index}
									/>
								))}
						</div>
					</>
				)}
			</div>
		</div>
	)
}
